/**
 * ListView.jsx
 * Vista de lista compacta reutilizable
 */
import { Badge } from "./ui/badge";
import { ChevronRight } from "lucide-react";

export default function ListView({ 
  items = [], 
  renderItem,
  onItemClick,
  showDivider = true
}) {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 divide-y divide-slate-200 dark:divide-slate-700">
      {items.map((item, idx) => (
        <div 
          key={item.id || idx}
          className="flex items-center justify-between p-3 hover:bg-slate-50 dark:hover:bg-slate-700/50 cursor-pointer transition-colors"
          onClick={() => onItemClick?.(item)}
        >
          {renderItem ? renderItem(item) : (
            <>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <p className="font-medium text-sm text-slate-900 dark:text-white truncate">
                    {item.titulo || item.cliente || item.name || 'Sin título'}
                  </p>
                  {item.prioridad && (
                    <Badge 
                      variant="outline"
                      className={`text-xs ${
                        item.prioridad === 'critica' || item.prioridad === 'alta' 
                          ? 'border-red-300 text-red-600' 
                          : item.prioridad === 'media' 
                          ? 'border-yellow-300 text-yellow-600'
                          : 'border-green-300 text-green-600'
                      }`}
                    >
                      {item.prioridad}
                    </Badge>
                  )}
                </div>
                <p className="text-xs text-slate-500 dark:text-slate-400 truncate mt-0.5">
                  {item.descripcion || item.notas || item.email || ''}
                </p>
              </div>
              <div className="flex items-center gap-3 ml-4">
                <Badge 
                  variant="secondary"
                  className={`text-xs ${
                    item.estado === 'completado' || item.estado === 'resuelto' 
                      ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' 
                      : item.estado === 'en_proceso' || item.estado === 'en_progreso'
                      ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400'
                      : 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400'
                  }`}
                >
                  {item.estado || 'N/A'}
                </Badge>
                <ChevronRight className="w-4 h-4 text-slate-400" />
              </div>
            </>
          )}
        </div>
      ))}
      
      {items.length === 0 && (
        <div className="text-center py-12 text-slate-400">
          No hay items para mostrar
        </div>
      )}
    </div>
  );
}
